module.exports = __webpack_public_path__ + "img/refer_sidemenu_blue.b35740dd.svg";